import { handleActions } from 'redux-actions';
import { setSourceStatementLoaded } from 'store/actions/load-source-statement-actions';

export default handleActions(
  {
    [setSourceStatementLoaded]: (state, { payload }) => payload,
  },
  false, // initial state
);
